import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { feeManageRoute } from './manage.route';

export function editFeeRoute(name: string): RouteConfig {
  return {
    ...feeManageRoute(name, ':feeId', true),
    beforeEnter: (to: any, from: any, next: any) => {
      store.commit('fee/setId', tryParseInt(to.params.feeId));
      Promise.all([
        store.dispatch('fee/get'),
        store.dispatch('schedule/getByEntity', { entityId: to.params.feeId.toString(), entityType: TableName.Fee })
      ])
        .then(() => next())
        .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych składki.' }));
    }
  };
}
